<template>
  <div>
    <Header v-bind:HeaderCheck = "HeaderCheck"></Header>
    <div id="content" style="background-color: white">
      <div id="breadcrumb"  style="height: 70px;background-color: #F6F7FB">
        <!-- breadcrumb starts-->
        <div class="container">
        </div>
      </div>
      <!--breadcrumbs ends -->
      <div class="container">
        <div class="one-half">
          <section class="flex-container">
            <div class="flexslider single-portfolio-item-slider">
              <ul class="slides round">
                <li>
                  <img src="static/img/aboutTeam/img_cloudhearing.png" alt=" "/>
                </li>
<!--                <li>-->
<!--                  <img src="static/img/aboutTeam/位图.png" alt=" "/>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <img src="static/img/aboutTeam/位图.png" alt=" "/>-->
<!--                </li>-->
              </ul>
            </div>
          </section>
        </div>
        <div class="one-half">
          <h4>{{$t('about.part1.title')}}</h4>
          <p >{{$t('about.part1.text')}}</p>
          <ul class="bar_graph" style="margin-top: 40px">
            <!-- skill graph starts -->
            <li>
              <p class="skill-graph-style-p">
                <i class="icon-circle"></i>{{$t('about.part1.tip1')}}
              </p>
              <div class="bar-wrap">
                <span data-width="80"></span>
              </div>
            </li>
            <li>
              <p class="skill-graph-style-p">
                <i class="icon-circle"></i>{{$t('about.part1.tip2')}}
              </p>
              <div class="bar-wrap">
                <span data-width="60"></span>
              </div>
            </li>
            <li>
              <p class="skill-graph-style-p">
                <i class="icon-circle"></i>{{$t('about.part1.tip3')}}
              </p>
              <div class="bar-wrap">
                <span data-width="40"></span>
              </div>
            </li>
            <li>
              <p class="skill-graph-style-p">
                <i class="icon-circle"></i>{{$t('about.part1.tip4')}}
              </p>
              <div class="bar-wrap">
                <span data-width="40"></span>
              </div>
            </li>
          </ul>
          <!--skill graph ends -->
        </div>
        <div class="horizontal-line">
        </div>
        <div class="one">
          <h3>{{$t('about.part2.title')}}</h3>
          <div class="flexslider team-member-slider ">
            <ul class="slides" style="margin-bottom: 100px">
              <li>
                <div class="one-fourth">
                  <div class="team-member">
                    <!-- team member starts -->
                    <div class="avatar">
                      <img src="static/img/aboutTeam/img_team_1.png" alt=" "/>
                    </div>
                  </div>
                  <!-- team member ends -->
                </div>
                <div class="one-fourth">
                  <div class="team-member">
                    <!-- team member starts -->
                    <div class="avatar">
                      <img src="static/img/aboutTeam/img_team_2.png" alt=" "/>
                    </div>
                  </div>
                  <!-- team member ends -->
                </div>
                <div class="one-fourth">
                  <div class="team-member">
                    <!-- team member starts -->
                    <div class="avatar">
                      <img src="static/img/aboutTeam/img_team_3.png" alt=" "/>
                    </div>
                  </div>
                  <!-- team member ends -->
                </div>
                <div class="one-fourth">
                  <div class="team-member">
                    <!-- team member starts -->
                    <div class="avatar">
                      <img src="static/img/aboutTeam/img_team_4.png" alt=" "/>
                    </div>
                  </div>
                  <!-- team member ends -->
                </div>
              </li>
              <li>
                <div class="one-fourth">
                  <div class="team-member">
                    <!-- team member starts -->
                    <div class="avatar">
                      <img src="static/img/aboutTeam/img_team_5.png" alt=" "/>
                    </div>
                  </div>
                  <!-- team member ends -->
                </div>
                <div class="one-fourth">
                  <div class="team-member">
                    <!-- team member starts -->
                    <div class="avatar">
                      <img src="static/img/aboutTeam/img_team_6.png" alt=" "/>
                    </div>
                  </div>
                  <!-- team member ends -->
                </div>
                <div class="one-fourth">
                  <div class="team-member">
                    <!-- team member starts -->
                    <div class="avatar">
                      <img src="static/img/aboutTeam/img_team_7.png" alt=" "/>
                    </div>
                  </div>
                  <!-- team member ends -->
                </div>
                <div class="one-fourth">
                  <div class="team-member">
                    <!-- team member starts -->
                    <div class="avatar">
                      <img src="static/img/aboutTeam/img_team_8.png" alt=" "/>
                    </div>
                  </div>
                  <!-- team member ends -->
                </div>
              </li>
<!--              <li>-->
<!--                <div class="one-fourth">-->
<!--                  <div class="team-member">-->
<!--                    &lt;!&ndash; team member starts &ndash;&gt;-->
<!--                    <div class="avatar">-->
<!--                      <img src="images/team/people-5.jpg" alt=" "/>-->
<!--                    </div>-->
<!--                    <h4><a href="#">Jane Smith</a></h4>-->
<!--                    <h5>Art Director / CEO</h5>-->
<!--                    <ul class="team-member-links">-->
<!--                      &lt;!&ndash; header social links starts&ndash;&gt;-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-twitter"></i></a></li>-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-facebook"></i></a></li>-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-linkedin"></i></a></li>-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-skype"></i></a></li>-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-google-plus"></i></a></li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; team member ends &ndash;&gt;-->
<!--                </div>-->
<!--                <div class="one-fourth">-->
<!--                  <div class="team-member">-->
<!--                    &lt;!&ndash; team member starts &ndash;&gt;-->
<!--                    <div class="avatar">-->
<!--                      <img src="images/team/people-6.jpg" alt=" "/>-->
<!--                    </div>-->
<!--                    <h4><a href="#">John Doe</a></h4>-->
<!--                    <h5>Senior Web Developer</h5>-->
<!--                    <ul class="team-member-links">-->
<!--                      &lt;!&ndash; header social links starts&ndash;&gt;-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-twitter"></i></a></li>-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-facebook"></i></a></li>-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-linkedin"></i></a></li>-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-skype"></i></a></li>-->
<!--                      <li><a href="#" class="tooltip" title="Some Title"><i class="icon-google-plus"></i></a></li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; team member ends &ndash;&gt;-->
<!--                </div>-->
<!--                <div class="one-fourth">-->
<!--                  <div class="team-member">-->
<!--                    &lt;!&ndash; team member starts &ndash;&gt;-->
<!--                    <div class="avatar">-->
<!--                      <img src="images/team/people-7.jpg" alt=" "/>-->
<!--                    </div>-->
<!--                    <div class="member-info">-->
<!--                      <h4><a href="#">John Doe</a></h4>-->
<!--                      <h5>Senior Web Developer</h5>-->
<!--                      <ul class="team-member-links">-->
<!--                        &lt;!&ndash; header social links starts&ndash;&gt;-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-twitter"></i></a></li>-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-facebook"></i></a></li>-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-linkedin"></i></a></li>-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-skype"></i></a></li>-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-google-plus"></i></a></li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; team member ends &ndash;&gt;-->
<!--                </div>-->
<!--                <div class="one-fourth">-->
<!--                  <div class="team-member">-->
<!--                    &lt;!&ndash; team member starts &ndash;&gt;-->
<!--                    <div class="avatar">-->
<!--                      <img src="images/team/people-8.jpg" alt=" "/>-->
<!--                    </div>-->
<!--                    <div class="member-info">-->
<!--                      <h4><a href="#">John Doe</a></h4>-->
<!--                      <h5>Senior Web Developer</h5>-->
<!--                      <ul class="team-member-links">-->
<!--                        &lt;!&ndash; header social links starts&ndash;&gt;-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-twitter"></i></a></li>-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-facebook"></i></a></li>-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-linkedin"></i></a></li>-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-skype"></i></a></li>-->
<!--                        <li><a href="#" class="tooltip" title="Some Title"><i class="icon-google-plus"></i></a></li>-->
<!--                      </ul>-->
<!--                      c-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; team member ends &ndash;&gt;-->
<!--                </div>-->
<!--              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'

const HeaderCheck = {
  tip1: '',
  tip2: '',
  tip3: '',
  tip4: 'current',
  tip5: ''
}
export default {
  name: 'About',
  components: {Footer, Header},
  data: function () {
    return {
      HeaderCheck: HeaderCheck
    }
  },
  activated () {
    // this.$router.go(0)
    window.location.reload()
  },
  inject: ['reload'],
  watch: {
    // 检测路由参数发生改变时，刷新当前页面 调用
    '$route': function () {
      console.log('路由发送变化')
      this.reload()
    }
  }
}
</script>

<style scoped>
.skill-graph-style-p {
  font-size: 16px;
  line-height: 32px;
  margin-top: 0;
}
.skill-graph-style-p i {
  font-size: 0.01em;
}
</style>



// WEBPACK FOOTER //
// src/components/view/About.vue